<template>
  <div class="form-group">
    <label :for="name" class="bold mr-1" :class="{'text-info': hasValue}">
      {{ label }}:
    </label>
    <input type="text" :name="name" v-model="modelValue" class="form-control" />
  </div>
</template>

<script>
export default {
  props: {
    name: {type: String, required: true},
    label: {type: String, required: true},
    operatorValue: {type: String, default: ''},
    value: {type: String, default: ''},
  },

  /**
   * Variables (models).
   */
  data () {
    return {
      modelValue: this.value,
    }
  },

  /**
   * Computed values
   */
  computed: {

    hasValue() {
      return (this.value !== null) && (this.value !== '');
    }

  },

  /**
   * Functions (methods).
   */
  methods: {
  },
}
</script>
